import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Expenses from "@/pages/Expenses";
import ExpenseCreate from "@/pages/ExpenseCreate";
import ExpenseDetail from "@/pages/ExpenseDetail";
import { Approvals, Payments } from "@/pages/Queues";
import Income from "@/pages/Income";
import Centres from "@/pages/Centres";
import Companies from "@/pages/Companies";
import Projects from "@/pages/Projects";
import PnL from "@/pages/PnL";
import Budgets from "@/pages/Budgets";
import Reports from "@/pages/Reports";
import Users from "@/pages/Users";
import Audit from "@/pages/Audit";
import Vendors from "@/pages/Vendors";
import ProfitShare from "@/pages/ProfitShare";
import Assets from "@/pages/Assets";
import AssetDetail from "@/pages/AssetDetail";
import MyQueue from "@/pages/MyQueue";
import ApprovalMatrix from "@/pages/ApprovalMatrix";
import Emails from "@/pages/Emails";
import Settings from "@/pages/Settings";
import Procurement from "@/pages/Procurement";
import FileHealth from "@/pages/FileHealth";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/expenses" element={<Expenses />} />
            <Route path="/expenses/new" element={<ExpenseCreate />} />
            <Route path="/expenses/:id" element={<ExpenseDetail />} />
            <Route path="/approvals" element={<Approvals />} />
            <Route path="/payments" element={<Payments />} />
            <Route path="/income" element={<Income />} />
            <Route path="/centres" element={<Centres />} />
            <Route path="/companies" element={<Companies />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/budgets" element={<Budgets />} />
            <Route path="/pnl" element={<PnL />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/users" element={<Users />} />
            <Route path="/audit" element={<Audit />} />
            <Route path="/vendors" element={<Vendors />} />
            <Route path="/profit-share" element={<ProfitShare />} />
            <Route path="/assets" element={<Assets />} />
            <Route path="/assets/:id" element={<AssetDetail />} />
            <Route path="/my-queue" element={<MyQueue />} />
            <Route path="/matrix" element={<ApprovalMatrix />} />
            <Route path="/emails" element={<Emails />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/file-health" element={<FileHealth />} />
            <Route path="/procurement/requests" element={<Procurement />} />
            <Route path="/procurement/quotations" element={<Procurement />} />
            <Route path="/procurement/orders" element={<Procurement />} />
          </Route>
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
